/** Default side length (in PDF points) for a newly created marker bbox. */
export const DEFAULT_BBOX_SIDE_PDF = 15;

// A corner drag that would shrink a bbox below this side length (PDF points) is ignored.
export const MIN_BBOX_SIDE_PDF = 2;

// Group label for a route whose cable type has no name.
export const NO_CABLE_TYPE_LABEL = "(no-type)";
